import { render, staticRenderFns } from "./BaseIframeRow.vue?vue&type=template&id=2679bc7a&scoped=true&"
import script from "./BaseIframeRow.vue?vue&type=script&lang=js&"
export * from "./BaseIframeRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseIframeRow.vue?vue&type=style&index=0&id=2679bc7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679bc7a",
  null
  
)

export default component.exports